import { render, staticRenderFns } from "./AssayProtocols.vue?vue&type=template&id=31c7bd06&"
import script from "./AssayProtocols.vue?vue&type=script&lang=js&"
export * from "./AssayProtocols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports